import { formatDistanceToNow } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';

const getTimeAgoLabel = (date?: Date | string | null, now?: Date): string => {
  if (!date) {
    return 'n/a';
  }

  const createdAt = new Date(date);
  if (Number.isNaN(createdAt.getTime())) {
    return 'n/a';
  }

  const current = now ?? new Date();
  const diffMs = current.getTime() - createdAt.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);

  if (diffSeconds < 60) {
    return `+${diffSeconds}s`;
  }

  return formatDistanceToNow(createdAt, { addSuffix: true });
};

export const useTimeAgo = (date?: Date | string | null): string => {
  const [currentTime, setCurrentTime] = useState<Date>(() => new Date());

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return useMemo(() => getTimeAgoLabel(date, currentTime), [date, currentTime]);
};
